module.exports = __webpack_public_path__ + "media/images/awesome-info-circle-e4086e94c0d16366beae0cb2ff750872.svg";